import * as allPageFr from './fr/import';
import * as allPageEn from './en/import';
import * as allPageFrGabed from './fr/gabed/importGabed';
import * as allPageFRLogisitique from './fr/logistique/importLogistique';
import * as allPageFrBaux from './fr/baux/importBaux';
import * as allPageFrCompta from './fr/compta/importCompta';
import * as allPagePresse from './fr/presse/importPresse';
import * as allPageAchat from './fr/achat/importAchat';

const generalTraductionFr = [];

function allTraductionFR(allTraduction) {
  Object.keys(allTraduction).forEach((key) => {
    generalTraductionFr[key] = allTraduction[key];
  });
}
// Pour les futurs modules il faut créer le fichier de translate import, l'import et
// appeller la fonction en dessous avec en parametre la liste de toutes les translate
allTraductionFR(allPageFr.PAGES);
allTraductionFR(allPageFrGabed.default);
allTraductionFR(allPageFRLogisitique.default);
allTraductionFR(allPageFrBaux.default);
allTraductionFR(allPageFrCompta.default);
allTraductionFR(allPagePresse.default);
allTraductionFR(allPageAchat.default);

// eslint-disable-next-line import/prefer-default-export
export const TRANSLATE = {
  fr: generalTraductionFr,
  en: allPageEn.PAGES,
};
